import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  AdministrationCustomerUserService,
  CustomerUserModel,
  CustomerUserRequest,
  CustomerUserEditRequest,
  CustomerUserListRequest
} from '../autogenerated';
import { REQUEST_OPTIONS } from '../constants';
import { RequestOptionsJsonType, RequestOptionsVoidType } from '../types';

@Injectable({ providedIn: 'root' })
export class AdministrationCustomerUserApiService {
  constructor(private apiService: AdministrationCustomerUserService) {}

  public activateCustomerUser(customerId: string, userId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerUserModel> {
    return this.apiService.adminCustomerUserActivate(customerId, userId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public addCustomerUser(customerId: string, body: CustomerUserRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerUserModel> {
    return this.apiService.adminCustomerUserAdd(customerId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public deleteCustomerUser(customerId: string, userId: string, requestOptions: RequestOptionsVoidType = REQUEST_OPTIONS): Observable<void> {
    return this.apiService.adminCustomerUserDelete(customerId, userId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editCustomerUser(customerId: string, userId: string, body: CustomerUserEditRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerUserModel> {
    return this.apiService.adminCustomerUserEdit(customerId, userId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public getCustomerUser(customerId: string, userId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerUserModel> {
    return this.apiService.adminCustomerUserGet(customerId, userId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public listCustomerUsers(customerId: string, body: CustomerUserListRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerUserModel[]> {
    return this.apiService.adminCustomerUserList(customerId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public resendCustomerUserInvitation(customerId: string, userId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerUserModel> {
    return this.apiService.adminCustomerUserResendInvitation(customerId, userId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public suspendCustomerUser(customerId: string, userId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerUserModel> {
    return this.apiService.adminCustomerUserSuspend(customerId, userId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
}
